/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';
import { InputText } from "primereact/inputtext";
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Checkbox } from "primereact/checkbox";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';



import { FaCircleMinus, FaCirclePlus } from "react-icons/fa6";





import MarkupViewer from '../../MarkupViewer';
import FileUploader from '../../FileUploader'
import MarkupChanger from '../../MarkupChanger';
import FormBuilder from '../../FormBuilder';
import LayoutChanger from '../../LayoutChanger';

import { setLPDetails } from '../../../slices/createLPSlice';

import { useLocation } from 'react-router-dom';

import './IdTemplate.css';
import { LandingPageServe } from '../../../services/api/LandingPageServ';


const IdTemplate = () => {
  const toast = useRef(null);
  const lpDetails = useSelector((state) => state.createLp.data);
  const isEditable = useSelector((state) => state.auth.isEditable);
  const isLogged = useSelector((state) => state.auth.isLogged);
  const dispatch = useDispatch();
  const [routerUrl , setRouterUrl] = useState('')
  const [editMode, setEditMode] = useState(isEditable);
  const [currentEditSection, setCurrentEditSection] = useState('');
  const [viewUploader, setViewUploader] = useState(false);
  const [viewEditor, setViewEditor] = useState(false);
  const [viewFormBuilder, setViewFormBuilder] = useState(false);
  const [viewLayoutChanger, setViewLayoutChanger] = useState(false)
  const [layout, setLayout] = useState(lpDetails.lplayout);
  const [templateNo , setTemplateNo] = useState(lpDetails.templateNo);
  const [content, setContent] = useState(null)
  const [markup, setMarkup] = useState('');
  const location = useLocation();
  const [emailLayout, setemailLayout] = useState(lpDetails.emaillayout);
  // const [formFields , setformFields] = useState(lpDetails.fields);
  // const [isWebinar, setisWebinar] = useState(false);

  const getFormErrorMessage = (name) => {
    return errors[name] ? <small className="p-error"  style={{ display : "flex" , marginTop:'2px',marginBottom : "0px"  }}>{errors[name].message}</small> : <small className="p-error">&nbsp;</small>;
  };




  const {
    formState: { errors },
    handleSubmit,
    control,
    reset
  } = useForm();

  const {
    fields: itemFields,
    append: appendItem,
    remove: removeItem
  } = useFieldArray({
    control,
    name: "Items"
  })



  useEffect(() => {
    // console.log(lpDetails)
    setRouterUrl(location.pathname);
    if (isLogged) {
      setEditMode(isEditable)
    } else {
      setEditMode(false)
    }

    if (lpDetails._id) {
      setLayout(lpDetails.lplayout);
      setTemplateNo(lpDetails.templateNo);
      // setformFields(lpDetails.fields);
      document.title =lpDetails['lplayout']['title']['text'];
    }
    if (lpDetails.fields.length > 0) {
      reset()
      for (const f of lpDetails.fields) {
        appendItem(f)
      }
    }
  }, [lpDetails])


  const handleDragEnd = (result) => {
    if (!result.destination) {
        return;
    }

    const items = Array.from(itemFields);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    dispatch(setLPDetails({ fields: items }));
}; 

  const dispatchLayout = (obj) => {
    dispatch(setLPDetails({ lplayout: { ...layout, ...obj , ...templateNo } }));
  }

  const dispatchEmailLayout=(obj) => {
    let footerObj = {}
    if(obj['headerLogo']){
      footerObj = {footerLogo:{ url: obj.headerLogo.url}}
      setLPDetails({emaillayout: {...emailLayout , ...footerObj}})
    } 
    dispatch(setLPDetails( { emaillayout: { ...emailLayout, ...obj , ...templateNo }}))
  }
  const dispatchFields = (data) => {
    dispatch(setLPDetails({ fields: [...itemFields, ...[data]] }))
  }

  const onFormSubmit = async (data) => {
    try {
      delete data['Items']
      if (!isEditable) {
        await LandingPageServe.saveform({ lpId: lpDetails._id, lead: data });
      }
      reset()
      toast.current.show({ severity: 'success', summary: 'Success', detail: 'Submitted successfully' });
      window.open(lpDetails.assetLink,"_self")
    } catch (error) {
      // console.log(error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: error.message });

    }
  };

  const handleClick = (type) => {
    setCurrentEditSection(type)
    if (type === 'HEADER_LOGO' || type === 'HERO_IMAGE' || type === 'FOOTER_LOGO') {
      setViewUploader(true);
    
    }
    if (type === 'TITLE') {
      setContent(layout.title)
      setViewLayoutChanger(true)
    }
    if (type === 'FORM_TITLE') {
      setContent(layout.formTitle)
      setViewLayoutChanger(true)
    }

    if (type === 'HERO_CONTENT') {
      setMarkup(layout.heroContent)
      setViewEditor(true)
    }
    if (type === 'ACTION_BTN') {
      setContent(layout?.actionButton)
      setViewLayoutChanger(true)
    }
    if (type === 'FOOTER_CONTENT') {
      setMarkup(layout.footerContent);
      setViewEditor(true)
    }
  };

  const handleAdd = () => {
    setViewFormBuilder(true)
  };

  const handleRemove = (i) => {
    removeItem(i)
    const updatedFields = lpDetails['fields'].filter((ele,e)=> ele['name'] !== lpDetails['fields'][i]['name']);
    dispatch(setLPDetails({ fields: [...updatedFields]}));
  };

  const handleCloseEditor = (data , isWebinar , duration , webinarTitle) => {
    
    let obj = {}
    if (currentEditSection === 'HERO_CONTENT') {
      obj = { 
        heroContent: data ,
        isWebinar : isWebinar || false,
        duration : duration || null,
        webinarTitle :webinarTitle || null
      }

      // setisWebinar(isWebinar);
    }
    if (currentEditSection === 'FOOTER_CONTENT') {
      obj = { footerContent: data }
    }

    
   

    setViewEditor(false)
    dispatchLayout(obj);
    // dispatchEmailLayout(obj);
  }

  const handleCloseUploader = (data,width,height) => {
    // console.log(width,height);
    if (data) {
      
      let obj = {}
      if (currentEditSection === 'HEADER_LOGO') {
        obj = { headerLogo: { url: data.Location , 
                              width : width ||  '420px', 
                              height : height || 'auto'} 
              }
             
             
      }
      if (currentEditSection === 'HERO_IMAGE') {
        obj = { heroImage: { url: data.Location , 
                            width : width || '360px' , 
                            height : height || 'auto'} 
              }
             
      }
      if (currentEditSection === 'FOOTER_LOGO') {
        obj = { footerLogo:{ url: data.Location , 
                              width : width || '250px' , 
                              height :height || 'auto'} 
              }
      }
      dispatchLayout(obj);
      // dispatchEmailLayout(obj);
    }
    setViewUploader(false)
  }

  const handleCloseBuilder = (data) => {
    setViewFormBuilder(false);
    if (data && Object.keys(data).length > 0) {
      appendItem(data);
      dispatchFields(data)
    }
  }


  const handleCloseLayoutChanger = (data) => {
    // console.log(data);
    let obj = {}
    if (data) {
      if (currentEditSection === 'TITLE') {
        obj = {
          title: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            subtitle : data.subtitle
          }
        }
      }
      if (currentEditSection === 'ACTION_BTN') {
        obj = {
          actionButton: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      if (currentEditSection === 'FORM_TITLE') {
        obj = {
          formTitle: {
            text: data.text,
            backgroundColor: data.backgroundColor,
            textColor: data.textColor,
            link: data.link
          }
        }
      }
      dispatchLayout(obj)
      // dispatchEmailLayout(obj);
    }
    setViewLayoutChanger(false)
  }

  const getAddRemove = (i) => {
    return (
      <>
        <FaCircleMinus onClick={(() => handleRemove(i))} className='mt-3' style={{ color: "red" , cursor :'default' }} />
        {(itemFields.length - 1) === i && <FaCirclePlus onClick={(() => handleAdd())} className='mt-3 ml-2' style={{ color: "green" , cursor :'default' }} />}

      </>
    )
  }

  const getField = (item, i) => {
    return (
      <>
       {item.type !== 'check' &&
        <div>
                               <label className='field-label'>{item?.label}</label>
                          </div>

  }
        
        {
          item.type === 'text' &&
         
          <span className='field'>
           
            <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '5px'  }}>
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (

                  <>
                     {/* <label htmlFor={field.name} className={classNames({ 'p-error': errors.value })}></label>  */}
                   
                    <span className='w-336'>
                  
                      <InputText id="text"   value={field.value} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                    </span>
                  </>
                )}
              />
              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div >{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>

        }
        {
          item.type === 'select' &&
         <span style={{marginTop : '5px'}}>

          
          <span className='field id-dropdown'>

            <div className="flex justify-content-center" key={item.id}>
         
              <Controller
                style={{ width: "277px", }}
                id="dropdown"
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                      
                      <Dropdown
                        id={field.name}
                        value={field.value}
                        optionLabel="label"
                        // placeholder={item.label}
                        options={item.options}
                        focusInputRef={field.ref}
                        onChange={(e) => field.onChange(e.value)}
                        className={classNames({ 'p-invalid': fieldState.error })}
                      />
                  </>

                )}
              />

              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
         </span>
        }
        {
          item.type === 'number' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ height: "45px" , marginTop : '5px'  }} >
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                    {/* <label htmlFor={field.name}  className={classNames({ 'p-error': errors.value })}></label> */}
                    <span className='w-336'>
                      
                      <InputText keyfilter="int" id={field.name} value={field.value}  className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.target.value)} />
                      {/* <label htmlFor={field.name}>{item.label}*</label> */}
                    </span>
                  </>
                )}
              />
              <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
        {
  item.type === 'email' &&
  <span className="field">
    <div
      className="flex justify-content-center"
      style={{ height: "45px", marginTop: "5px" }}
    >
      <Controller
        name={item.name}
        control={control}
        rules={{
          required: item.message,
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Please enter a valid email address"
          }
        }}
        render={({ field, fieldState }) => (
          <>
            <span className="w-336-bc">
              <InputText
                id={field.name}
                value={field.value}
                type="email"
                className={classNames({ 'p-invalid': fieldState.error })}
                onChange={(e) => field.onChange(e.target.value)}
              />
            </span>
          </>
        )}
      />
      <div className={`${itemFields.length - 1 === i && editMode ? 'ml-2' : 'ml-5'}`}>
        {editMode && <div>{getAddRemove(i)}</div>}
      </div>
    </div>

    <span>{getFormErrorMessage(item.name)}</span>
  </span>
}

        {
          item.type === 'check' &&
          <span className='field'>
            <div className="flex justify-content-center" style={{ width: "100%" , height: "auto" , marginTop : '0px' }}>
              <Controller
                name={item.name}
                control={control}
                rules={{ required: item.message }}
                render={({ field, fieldState }) => (
                  <>
                    <label htmlFor={field.name} className={classNames({ 'p-error': errors.checked })}></label>
                    <Checkbox inputId={field.name} checked={field.value} inputRef={field.ref} className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => field.onChange(e.checked)} />
                  </>
                )}
              />
              <label htmlFor="ingredient1" className="ml-2 opt-in"><MarkupViewer htmlString={item.label}></MarkupViewer></label>
              <div className={`${itemFields.length - 1 === i  && editMode ? 'ml-2' : 'ml-5'}`}>
                {editMode && <div className='check'>{getAddRemove(i)}</div>}
              </div>
            </div>
            <span>{getFormErrorMessage(item.name)}</span>
          </span>
        }
      </>

    )
  }






  return (
    <>
      <Toast ref={toast}></Toast>
      <div className='relative customFont'>
        <div className="grid">
          <div className={`md:col-offset-0 md:col-12 col-12 text-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HEADER_LOGO')) : undefined}>
            <img className="headerLogo" style={{width : layout?.headerLogo?.width || '420px' , height : layout?.headerLogo?.height || 'auto'}} src={layout?.headerLogo?.url} alt="Header logo" />
          </div>
        </div>
        <div className="grid headerBg" style={{ backgroundColor: layout?.title?.backgroundColor || "#63B5DA", color: layout?.title?.textColor || 'white' }} >
          <div className={`md:col-offset-1 md:col-5 col-12 text-left ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('TITLE')) : undefined}>
            <div className="heading">
              <h1 className="headerTitle" style={{ color: layout?.title?.textColor || 'white' , paddingBottom : (layout?.title?.subtitle && layout?.title?.subtitle !== '') ? '0px' : '40px' }}>{layout?.title?.text} </h1>
              {layout?.title?.subtitle ? (
                <p className="headerSubTitleLP" style={{ color: layout?.title?.textColor || 'white' }}>{layout?.title?.subtitle}</p>            
            ) : ('')}
                 {/* <p className="headerSubTitle" style={{ color: layout?.title?.textColor || 'white' }}>{layout?.title?.subtitle}</p>             */}
             
            
            </div>
          </div>
        
   
        </div>
        <div className='row responsive-content'>
          <div className='col-7'>
          <div className="grid responsive-des" >
          <div style={{fontSize : "16px"}} className={`md:col-offset-1 md:col-10 col-12 text-left description res-des ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_CONTENT')) : undefined}>
            {layout?.isWebinar? (
               <div className="mt-4 webinar-div">
               <p className="webinar-text"><strong>{layout?.webinarTitle}</strong></p>
               <p className="webinar-duration">Duration: {layout?.duration}</p>
              </div>
            ) : ('')}
            <MarkupViewer htmlString={layout?.heroContent} ></MarkupViewer>
          </div>
        </div>
        <div className="row responsiveImageSection">
          <div className={`md:col-offset-1 md:col-5 col-12 text-left pdi-0 ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('HERO_IMAGE')) : undefined} >
            <img className="simg" style={{width : layout?.heroImage?.width || '360px' , height : layout?.heroImage?.height || 'auto'  }} src={layout?.heroImage?.url} alt="Hero Image" />
          </div>
        </div>
          </div>
          <div className='col-3'>
          <div className="md:col-offset-1" >
          <div className="text-center formStyling">
            <div style={{ color: layout?.formTitle?.textColor , backgroundColor: layout?.formTitle?.backgroundColor , padding : '12px',margin : '0' , padding : '0' }}>

            <h2 style={{ color: layout?.formTitle?.textColor ,  padding : '18px' }}> <span className={` ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FORM_TITLE')) : undefined} style={{ color: layout?.formTitle?.textColor }}>{layout?.formTitle?.text}</span>   {itemFields.length === 0 && editMode && <FaCirclePlus onClick={() => handleAdd()} className='mt-3' style={{ color: "green" }} />}</h2>
            </div>
            <form class="form-id-lp" onSubmit={handleSubmit(onFormSubmit)}>

              {(routerUrl.includes('preview') || routerUrl.includes('view-lp')) &&
              <div>
              {
                itemFields &&
                itemFields.map((item, index) => <div key={item.id}> {getField(item, index)}</div >)
              }
              </div>
              }

              {(routerUrl.includes('create-lp') || routerUrl.includes('edit-lp')) &&
              <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId="list">
                          {(provided) => (
                              <div className="custom-cursor" {...provided.droppableProps} ref={provided.innerRef}>
                                  {itemFields.map((item, index) => (
                                      <Draggable style={{cursor : 'move'}} key={item.id} draggableId={item.id} index={index}>
                                          {(provided) => (
                                              <div  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                              
                                              {/* {item.type !== 'check' &&
                                            <div>
                                            <label className='field-label'>{item?.label}</label>
                                        </div>
                                              }  */}
                                                  <div>{getField(item, index)}</div>
                                              </div>
                                          )}
                                      </Draggable>
                                  ))}
                                  {provided.placeholder}
                              </div>
                          )}
                      </Droppable>
                  </DragDropContext>
              }
    {itemFields.length > 0 &&
              <div className={`flex justify-content-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('ACTION_BTN')) : undefined}>
                <Button label={layout?.actionButton?.text} style={{ backgroundColor: layout?.actionButton?.backgroundColor || "#087d95", color: layout?.actionButton?.textColor || 'white' }} type="submit" outlined />
              </div>
}
            </form>
          </div>
          {/* <div className="grid" >
          <div className="col-12 text-left datasheetForm1">
            <div style={{ color: layout?.formTitle?.textColor , backgroundColor: layout?.formTitle?.backgroundColor , padding : '0' , margin : '0'}} >
            <h2 style={{ color: layout?.formTitle?.textColor ,  padding: '12px' }}> <span className={` ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('FORM_TITLE')) : undefined} style={{ color: layout?.formTitle?.textColor , backgroundColor: layout?.formTitle?.backgroundColor }}>{layout?.formTitle?.text}</span>
              {itemFields.length === 0 && editMode && <FaCirclePlus onClick={handleAdd} className='mt-3' style={{ color: "green" }} />}</h2>
            </div>
            <form onSubmit={handleSubmit(onFormSubmit)}>
              {
                itemFields &&
                itemFields.map((item, index) => <div key={item.id}> {getField(item, index)}</div>)
              }
              <div className={`flex justify-content-center ${editMode ? "u-hover--sparkle" : ""}`} onClick={editMode ? (() => handleClick('ACTION_BTN')) : undefined}>
                <Button label={layout?.actionButton?.text} style={{ backgroundColor: layout?.actionButton?.backgroundColor || "#087d95", color: layout?.actionButton?.textColor || 'white' }} type="submit" outlined />
              </div>
            </form>
          </div>
        </div> */}
    
          </div>
          </div>
        </div>
       
  
      </div>
      <div className={`grid ${editMode ? "u-hover--sparkle" : ""}`} style={{marginTop: '100px', marginBottom: '20px'}} onClick={editMode ? (() => handleClick('FOOTER_CONTENT')) : undefined}>
          <div className="col-12  text-center ">
            <MarkupViewer htmlString={layout?.footerContent}></MarkupViewer>
          </div>
        </div>
      {viewUploader && <FileUploader open={viewUploader} handleCloseUploader={handleCloseUploader}></FileUploader>}
      {viewEditor && <MarkupChanger open={viewEditor} text={markup}    isWebinarEnabled = {layout.isWebinar}
          webinarTitleVal = {layout.webinarTitle}
          durationVal = {layout.duration} handleCloseEditor={handleCloseEditor}></MarkupChanger>}
      {viewFormBuilder && <FormBuilder open={viewFormBuilder} data={markup} handleCloseBuilder={handleCloseBuilder}></FormBuilder>}
      {viewLayoutChanger && <LayoutChanger open={viewLayoutChanger} data={content} handleCloseLayoutChanger={handleCloseLayoutChanger}></LayoutChanger>}

    </>

  )
}

export default IdTemplate